module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('top-nav', {
    attrs: {
      "headerColor": "white"
    }
  }), (_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }) : _vm._e(), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "content article"
  }, [_c('div', {
    staticClass: "grid"
  }, [_c('div', {
    staticClass: "col-4_xs-12 titles"
  }, [_c('h2', [_vm._v("learn")]), _c('router-link', {
    attrs: {
      "to": {
        name: 'blog'
      }
    }
  }, [_c('h3', {
    staticClass: "category"
  }, [_vm._v("600state")])]), _c('h1', [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "author-date"
  }, [_c('h2', {
    staticClass: "author"
  }, [_vm._v(_vm._s(_vm.author))]), _c('h2', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.date))])]), _c('h4', {
    staticClass: "share",
    on: {
      "click": function($event) {
        _vm.share = !_vm.share
      }
    }
  }, [_vm._v("share"), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.share) ? _c('social', {
    attrs: {
      "meta": _vm.shareInfo
    }
  }) : _vm._e()], 1)], 1)], 1), _c('div', {
    staticClass: "col-8_xs-12"
  }, [_c('visual', {
    staticClass: "hero",
    attrs: {
      "image": _vm.hero.url,
      "background": "cover",
      "role": "img",
      "aria-label": _vm.heroCaption
    }
  }), (_vm.captions) ? _c('p', {
    staticClass: "heroCaptions",
    domProps: {
      "innerHTML": _vm._s(_vm.captions)
    }
  }) : _vm._e()], 1), (_vm.hero.url) ? _c('div', {
    staticClass: "col-5_xs-12",
    attrs: {
      "data-push-left": "off-4_xs-0"
    }
  }, [_c('div', {
    staticClass: "copy wysiwyg",
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  })]) : _vm._e()])]) : _vm._e()]), _c('bottom-nav', {
    attrs: {
      "footerColor": "white"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-160e173e"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Article.vue
// module id = 216
// module chunks = 1